import type { RoleConfig } from '../types.js';

export const priest: RoleConfig = {
  id: 'priest',
  faction: 'town',
  title: { ru: 'Священник', uk: 'Священник' },
  latin: 'PRIEST',
  number: '31',
  accent: '#f0e6c8',
  sub: '#a89c7a',
  ability: {
    ru: 'Раз за игру днём оглашает роль выбранного игрока — все слышат правду.',
    uk: 'Один раз за гру вдень оголошує роль обраного гравця — усі чують правду.',
  },
  abilities: [
    { key: 'reveal', phase: 'day', cadence: 'one-time', canSelfTarget: false, charges: 1 },
  ],
  victory: { type: 'town' },
};
